module.exports = __webpack_public_path__ + "img/ivo.1dbba83d.jpeg";